import { Icon } from 'types/Icon';

export const IconMultiselectableIOS = ({ ...restProps }: Icon) => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
  </svg>
);
